<template>
  <section class="w-full max-w-[408px] p-5 text-center">
    <section class="flex justify-center mb-5">
      <div class="bg-orange-100 dark:bg-orange-900/30 rounded-full p-2.5">
        <Icon name="general.exclamationTriangleOutline" size="base" class="text-orange-500" />
      </div>
    </section>

    <h2 class="text-base font-bold uppercase text-zinc-900 dark:text-zinc-100 mb-1">Reply Limit Reached</h2>

    <p class="text-sm text-zinc-900 dark:text-zinc-300 mb-5">
      Your plan includes {{ monthlyReplyLimit }} replies per month. You've reached your limit for this month.
    </p>

    <div class="flex flex-col gap-3">
      <Button
        type="solid"
        variant="blue"
        text="Upgrade to Get Unlimited Replies"
        class="!w-full"
        data-testid="reply-limit-modal-upgrade"
        @click="handleUpgrade"
      />
      <Button type="solid" variant="gray" text="Learn about Reply Limits" class="!w-full" data-testid="reply-limit-modal-learn" @click="handleLearnMore" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { Button } from '@/storybook/button';
import { Icon } from '@/storybook/icon';

interface Props {
  monthlyReplyLimit?: number;
  onClose?: () => void;
}

withDefaults(defineProps<Props>(), {
  monthlyReplyLimit: 0,
});

const handleUpgrade = () => {
  window.location.href = '/account/plans';
};

const handleLearnMore = () => {
  window.open('https://zight.com/pricing', '_blank', 'noopener,noreferrer');
};
</script>
